import { __rest, __assign } from 'tslib';
import React, { forwardRef } from 'react';
import { FormControlDesktop } from '../../../form-control/esm/desktop';
import { Popover } from '../../../popover/esm';
import { Arrow } from '../components/arrow/Component.js';
import { BaseSelect } from '../components/base-select/Component.js';
import { Field } from '../components/field/Component.js';
import { Optgroup } from '../components/optgroup/Component.js';
import 'classnames';
import '../../../badge/esm';
import '../../../checkbox/esm';
import '@alfalab/icons-glyph/CheckmarkCircleMIcon';
import '@alfalab/icons-glyph/CheckmarkMIcon';
import { OptionResponsive } from '../components/option/Component.responsive.js';
import { OptionsList } from '../components/options-list/Component.js';
import { Search } from '../components/search/Component.js';
import '@alfalab/icons-glyph/ChevronDownMIcon';
import '@alfalab/icons-glyph/ChevronDownSIcon';
import 'react-merge-refs';
import '@juggle/resize-observer';
import 'compute-scroll-into-view';
import 'downshift';
import '../../../shared/esm';
import '@alfalab/hooks';
import '../utils.js';
import '../components/native-select/Component.js';
import '../components/base-select/components/list-desktop/helpers/get-list-popover-desktop-props.js';
import '../list-popover-desktop-c68b8ae8.js';
import '../components/base-select/components/list-mobile/helpers/get-list-modal-mobile-props.js';
import '../components/base-select/components/list-mobile/helpers/get-list-bottom-sheet-mobile-props.js';
import '../components/base-select/components/list-mobile/list-mobile.js';
import '../components/base-select/components/list-mobile/list-bottom-sheet-mobile.js';
import '../mobile.module-2122fcd6.js';
import '../components/base-select/components/list-mobile/list-modal-mobile.js';
import '../components/clear-button/Component.js';
import '../../../button/esm';
import '@alfalab/icons-glyph/CrossCircleMIcon';
import '@alfalab/icons-glyph/CrossCircleSIcon';
import '../consts.js';
import '../components/option/desktop/Component.js';
import '../components/checkmark/Component.js';
import '../components/option/Component.js';
import '../components/option/mobile/Component.js';
import '../components/checkmark-mobile/Component.js';
import '../../../mq/esm';
import '../../../scrollbar/esm';
import '../../../input/esm';
import '@alfalab/icons-glyph/MagnifierMIcon';

var SelectDesktop = forwardRef(function (_a, ref) {
    var _b = _a.Arrow, Arrow$1 = _b === void 0 ? Arrow : _b, _c = _a.Field, Field$1 = _c === void 0 ? Field : _c, _d = _a.OptionsList, OptionsList$1 = _d === void 0 ? OptionsList : _d, _e = _a.Optgroup, Optgroup$1 = _e === void 0 ? Optgroup : _e, _f = _a.Option, Option = _f === void 0 ? OptionResponsive : _f, _g = _a.Search, Search$1 = _g === void 0 ? Search : _g, _h = _a.fieldProps, fieldProps = _h === void 0 ? {} : _h, restProps = __rest(_a, ["Arrow", "Field", "OptionsList", "Optgroup", "Option", "Search", "fieldProps"]);
    return (React.createElement(BaseSelect, __assign({ ref: ref, view: 'desktop', Option: Option, Field: Field$1, fieldProps: __assign({ FormControlComponent: FormControlDesktop }, fieldProps), Search: Search$1, Optgroup: Optgroup$1, OptionsList: OptionsList$1, Arrow: Arrow$1, Popover: Popover }, restProps)));
});

export { SelectDesktop };
